import { featureLinkInputs } from "../feature-link/inputs";

// Feature Cards links usually go to a partner, so every link here (each card
// and the button) starts on External Link reference. Only this component.
const externalFirstLinkInputs = featureLinkInputs.map(input =>
  input.name === "isInternalLink" ? { ...input, defaultValue: false } : input,
);

const IMAGE_TYPES = ["jpeg", "png", "svg", "webp", "gif"];

const defaultItem = {
  desktopImage:
    "https://cdn.builder.io/api/v1/image/assets%2F1e07bd57fd054601b600816e06494849%2F9d0ec7dc5a5f46d5a1ce7a8f4d17edde",
  mobileImage:
    "https://cdn.builder.io/api/v1/image/assets%2F1e07bd57fd054601b600816e06494849%2F1872a4e55cdb4083b7b39992d3663562",
  logo: "https://cdn.builder.io/api/v1/image/assets%2F481825b100e64e7f9a22a215d86e03f1%2F09e6a417694f459b8489aaa20ba09f5c",
  logoAlt: "Brand name",
  headline: "Featured headline copy",
  badge: "Badge Text",
  blockColor: "rgba(193, 210, 228, 1)",
  textColor: "rgba(20, 39, 69, 1)",
  whiteArrow: false,
  isInternalLink: false,
};

/**
 * Builder inputs for Feature Cards — the "Telehealth Feature" symbol's inputs
 * plus the CTA link on each card and on the button. The item name the symbol
 * used only as the logo's alt text is now a required "Logo alt text".
 */
export const featureCardsInputs = [
  {
    name: "heading",
    friendlyName: "Heading",
    type: "text",
    required: true,
    defaultValue: "Heading",
  },
  {
    name: "items",
    friendlyName: "Cards",
    type: "list",
    required: true,
    helperText:
      "Three per row on desktop (two on mobile). A 4th card or more wraps onto a new, centered row.",
    defaultValue: [defaultItem, defaultItem, defaultItem],
    subFields: [
      {
        name: "desktopImage",
        friendlyName: "Desktop image",
        type: "file",
        allowedFileTypes: IMAGE_TYPES,
        required: true,
        helperText: "Also used on tablet. Decorative: no alt text.",
      },
      {
        name: "mobileImage",
        friendlyName: "Mobile image",
        type: "file",
        allowedFileTypes: IMAGE_TYPES,
        required: true,
      },
      {
        name: "logo",
        friendlyName: "Logo",
        type: "file",
        allowedFileTypes: IMAGE_TYPES,
        required: true,
      },
      {
        name: "logoAlt",
        friendlyName: "Logo alt text",
        type: "text",
        required: true,
        helperText: "Type what the logo says.",
      },
      {
        name: "headline",
        friendlyName: "Headline",
        type: "text",
        required: true,
      },
      {
        name: "badge",
        friendlyName: "Badge",
        type: "text",
        helperText: "Red corner badge. Leave blank for none.",
      },
      {
        name: "blockColor",
        friendlyName: "Block color",
        type: "color",
        required: true,
      },
      {
        name: "textColor",
        friendlyName: "Text color",
        type: "color",
        required: true,
      },
      {
        name: "whiteArrow",
        friendlyName: "White arrow",
        type: "boolean",
        defaultValue: false,
      },
      ...externalFirstLinkInputs,
    ],
  },
  {
    name: "buttonText",
    friendlyName: "Button CTA",
    type: "text",
    required: true,
    defaultValue: "View All Telehealth",
  },
  // The button's link: same inputs, top level.
  ...externalFirstLinkInputs,
];
